import { render, staticRenderFns } from "./DebtProvidersFilter.vue?vue&type=template&id=afbc5ef0&scoped=true"
import script from "./DebtProvidersFilter.vue?vue&type=script&lang=js"
export * from "./DebtProvidersFilter.vue?vue&type=script&lang=js"
import style0 from "./DebtProvidersFilter.vue?vue&type=style&index=0&id=afbc5ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc5ef0",
  null
  
)

export default component.exports